import { combineReducers } from 'redux';
import { ActionType, getType } from 'typesafe-actions';

import { AllOffersState, GetOfferState, GetVoucherState, OfferState, PrintVoucherState, RequestVoucherState } from './Types';

import * as Actions from './Actions';
export type OfferAction = ActionType<typeof Actions>;

const allOffersInitialState: AllOffersState = {
    isCommunicating: false,
    data: [],
    error: false,
};

const getOfferInitialState: GetOfferState = {
    isCommunicating: false,
    data: {
        showVoucher: false,
        requiresSubscription: false,
        specialConditions: false,
        vehValidationRequired: false,
        showDealers: false,
    },
    error: false,
};

const requestVoucherInitialState: RequestVoucherState = {
    isCommunicating: false,
    error: false,
};

const getVoucherInitialState: GetVoucherState = {
    isCommunicating: false,
    data: {},
    error: false,
};

const printVoucherInitialState: PrintVoucherState = {
    isCommunicating: false,
    data: undefined,
    error: false,
};

export default combineReducers<OfferState, OfferAction>({

    allOffers: (state = allOffersInitialState, action) => {
        switch (action.type) {
            case getType(Actions.allOffersRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: [],
                };
            case getType(Actions.allOffersSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.allOffersFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: [],
                    error: true,
                };
            default:
                return state;
        }
    },
    getOffer: (state = getOfferInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getOfferRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.getOfferSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getOfferFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    requestVoucher: (state = requestVoucherInitialState, action) => {
        switch (action.type) {
            case getType(Actions.requestVoucherRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.requestVoucherSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.requestVoucherFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    getVoucher: (state = getVoucherInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getVoucherRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.getVoucherSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getVoucherFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    printVoucher: (state = printVoucherInitialState, action) => {
        switch (action.type) {
            case getType(Actions.printVoucherRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.printVoucherSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.printVoucherFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
});
